
// Used to provide fake and static data for tests or debugging

// PROPERTIES
export const kFakeFlashGrades = [
    {
        "id": 7,
        "name": "CM1",
        "rank": 7,
        "shortDescription": "La classe de CM1 correspond au premier niveau du cycle 3, la s\u00e9rie ne comportera donc que des questions de ce niveau",
        "gradeCycle": {
            "id": 3,
            "name": "Cycle 3",
            "shortDescription": "Le cycle 3, ou cycle de consolidation, comprend le cours moyen premi\u00e8re ann\u00e9e (CM1) et le cours moyen deuxi\u00e8me ann\u00e9e (CM2) ; le cycle de consolidation se poursuit au coll\u00e8ge, en classe de sixi\u00e8me."
        }
    },
    {
        "id": 8,
        "name": "CM2",
        "rank": 8,
        "shortDescription": "La classe de CM2 correspond au deuxi\u00e8me niveau du cycle 3, la s\u00e9rie sera donc compos\u00e9e de questions de CM1 et de CM2",
        "gradeCycle": {
            "id": 3,
            "name": "Cycle 3",
            "shortDescription": "Le cycle 3, ou cycle de consolidation, comprend le cours moyen premi\u00e8re ann\u00e9e (CM1) et le cours moyen deuxi\u00e8me ann\u00e9e (CM2) ; le cycle de consolidation se poursuit au coll\u00e8ge, en classe de sixi\u00e8me."
        }
    },
    {
        "id": 9,
        "name": "6\u1d49",
        "rank": 9,
        "shortDescription": "La classe de 6\u1d49 est le dernier niveau du cycle 3, la s\u00e9rie sera donc compos\u00e9e de questions de CM1, CM2 et 6\u1d49",
        "gradeCycle": {
            "id": 3,
            "name": "Cycle 3",
            "shortDescription": "Le cycle 3, ou cycle de consolidation, comprend le cours moyen premi\u00e8re ann\u00e9e (CM1) et le cours moyen deuxi\u00e8me ann\u00e9e (CM2) ; le cycle de consolidation se poursuit au coll\u00e8ge, en classe de sixi\u00e8me."
        }
    },
    {
        "id": 10,
        "name": "5\u1d49",
        "rank": 10,
        "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
        "gradeCycle": {
            "id": 4,
            "name": "Cycle 4",
            "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
        }
    },
    {
        "id": 11,
        "name": "4\u1d49",
        "rank": 11,
        "shortDescription": "La classe de 4\u1d49 correspond au deuxi\u00e8me niveau du cycle 4, la s\u00e9rie sera donc compos\u00e9e de questions de 5\u1d49 et de 4\u1d49",
        "gradeCycle": {
            "id": 4,
            "name": "Cycle 4",
            "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
        }
    },
    {
        "id": 12,
        "name": "3\u1d49",
        "rank": 12,
        "shortDescription": "La classe de 3\u1d49 est le dernier niveau du cycle 4, la s\u00e9rie sera donc compos\u00e9e de questions de 5\u1d49, 4\u1d49 et 3\u1d49",
        "gradeCycle": {
            "id": 4,
            "name": "Cycle 4",
            "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
        }
    }
]
export const kFakeKnowledgesMap = {
    "Definition": [
        {
            "id": 23,
            "identifier": 248,
            "keyword": "Hypoténuse",
            "definition": "Dans un triangle rectangle, l’hypoténuse est le côté le plus long du triangle rectangle. C'est aussi le côté en face de l'angle droit.",
            "type": "Definition",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 22,
                "identifier": 248,
                "task": "Reconnaître l’hypoténuse",
                "isPublished": true
            }
        },
        {
            "id": 7,
            "identifier": 198,
            "keyword": "Racine carrée d’un nombre",
            "definition": "\\(\\sqrt{a}\\) c’est le nombre positif qui au carré est égal à \\(a\\) : \\((\\sqrt{a})^{2} = a\\)",
            "type": "Definition",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 7,
                "identifier": 198,
                "task": "Appliquer des racines carrées",
                "isPublished": true
            }
        }
    ],
    "Method": [
        {
            "id": 46,
            "identifier": 257,
            "keyword": "Calculer une longueur avec Pythagore",
            "definition": "Pour calculer une longueur avec le théorème de Pythagore :\r\n- on écrit l’égalité du théorème de Pythagore ;\r\n- on substitue par les valeurs connues ;\r\n- on calcule ou on résout l'addition à trou avec une soustraction ;\r\n- on utilise la racine carrée pour trouver la longueur manquante.",
            "type": "Method",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 45,
                "identifier": 257,
                "task": "Calculer une longueur avec Pythagore",
                "isPublished": true
            }
        },
        {
            "id": 43,
            "identifier": 216,
            "keyword": "Développer avec la propriété de distributivité",
            "definition": "Pour développer : \r\n- on utilise la propriété \\( k \\times (a + b) = k \\times a + k \\times b \\), pour tout nombre \\( k \\), \\( a \\), et \\( b \\) ;\r\n- on réécrit l'expression sous la forme \\( k \\times (a + b) \\) ;\r\n- on identifie \\( k \\), \\( a \\), et \\( b \\) ;\r\n- on développe en \\( k \\times a + k \\times b \\) en substituant \\( k \\), \\( a \\), et \\( b \\) par les valeurs.",
            "type": "Method",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 42,
                "identifier": 216,
                "task": "Développer avec la propriété de distributivité",
                "isPublished": true
            }
        },
        {
            "id": 44,
            "identifier": 217,
            "keyword": "Factoriser avec la propriété de distributivité",
            "definition": "Pour factoriser : \r\n- on utilise la propriété \\( k \\times (a + b) = k \\times a + k \\times b \\), pour tout nombre \\( k \\), \\( a \\), et \\( b \\) ;\r\n- on réécrit l'expression sous la forme \\( k \\times a + k \\times b \\) ;\r\n- on identifie \\( k \\), \\( a \\), et \\( b \\) dans l'expression \\( k \\times a + k \\times b \\) ;\r\n- on factorise en  \\( k \\times (a + b) \\) en substituant \\( k \\), \\( a \\), et \\( b \\) par les valeurs.",
            "type": "Method",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 43,
                "identifier": 217,
                "task": "Factoriser avec la propriété de distributivité",
                "isPublished": true
            }
        },
        {
            "id": 58,
            "identifier": 209,
            "keyword": "Multiplier des fractions",
            "definition": "Pour multiplier des fractions : \r\n- on multiplie les numérateurs entre eux ;\r\n- on multiplie les dénominateurs entre eux.",
            "type": "Method",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 57,
                "identifier": 209,
                "task": "Multiplier des fractions",
                "isPublished": true
            }
        },
        {
            "id": 10,
            "identifier": 144,
            "keyword": "Soustraire des nombres relatifs",
            "definition": "Pour soustraire un nombre relatif à un autre :\n- on réécrit la différence sous la forme d'une somme du premier nombre et de l'opposé du second\n- on calcule la somme",
            "type": "Method",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 10,
                "identifier": 144,
                "task": "Soustraire des nombres relatifs",
                "isPublished": true
            }
        },
        {
            "id": 22,
            "identifier": 247,
            "keyword": "Écrire l’égalité de Pythagore",
            "definition": "Pour écrire l'égalité de Pythagore, on :\r\n- repère l'hypoténuse du triangle que l'on met au carré\r\n- cette longueur au carré est égale à la somme des carrés des longueurs des deux autres côtés",
            "type": "Method",
            "knowledgeGrade": {
                "id": 11,
                "name": "4ᵉ",
                "rank": 11,
                "shortDescription": "La classe de 4ᵉ correspond au deuxième niveau du cycle 4, la série sera donc composée de questions de 5ᵉ et de 4ᵉ"
            },
            "knowledgeLevelA": {
                "id": 21,
                "identifier": 247,
                "task": "Écrire l’égalité de Pythagore",
                "isPublished": true
            }
        }
    ]
}
export const kFakeSubthemesWithLevelAs = [
    {
        "id": 2,
        "name": "Base des nombres relatifs",
        "shortDescription": null,
        "isPublished": true,
        "subthemeTheme": {
            "id": 1,
            "identifier": 0,
            "name": "Nombres et calcul",
            "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
        },
        "subthemeLevelAs": [
            {
                "id": 4,
                "identifier": 319,
                "task": "D\u00e9terminer l\u0027oppos\u00e9 d\u0027un nombre relatif",
                "isPublished": true
            },
            {
                "id": 5,
                "identifier": 190,
                "task": "Rep\u00e9rer un point avec un nombre relatif sur une droite gradu\u00e9e",
                "isPublished": true
            }
        ]
    },
    {
        "id": 5,
        "name": "Calcul avec les nombres relatifs",
        "shortDescription": null,
        "isPublished": true,
        "subthemeTheme": {
            "id": 1,
            "identifier": 0,
            "name": "Nombres et calcul",
            "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
        },
        "subthemeLevelAs": [
            {
                "id": 8,
                "identifier": 142,
                "task": "Additionner des nombres relatifs de m\u00eame signe",
                "isPublished": true
            },
            {
                "id": 9,
                "identifier": 143,
                "task": "Additionner des nombres relatifs de signes diff\u00e9rents",
                "isPublished": true
            }
        ]
    },
    {
        "id": 3,
        "name": "Rep\u00e9rage dans le plan",
        "shortDescription": null,
        "isPublished": true,
        "subthemeTheme": {
            "id": 1,
            "identifier": 0,
            "name": "Nombres et calcul",
            "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
        },
        "subthemeLevelAs": [
            {
                "id": 6,
                "identifier": 182,
                "task": "Se rep\u00e9rer dans le plan",
                "isPublished": true
            }
        ]
    }
]
export const kFakeQuestions = [
    {
        "id": 52,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point B ?",
        "isVerified": true,
        "options": [
            {
                "id": 154,
                "proposal": "\\( (1 \\\\; 4) \\)",
                "explanation": "La position du point B sur l\u0027axe horizontal est : \\( 1 \\)\r\nLa position sur l\u0027axe vertical est : \\( 4 \\).\r\nSes coordonn\u00e9es sont (1; 4)",
                "isCorrect": true,
                "question": 52
            },
            {
                "id": 156,
                "proposal": "\\( (1\\ 4) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 52
            },
            {
                "id": 155,
                "proposal": "\\( (4 \\\\; 1) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 52
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 18,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1270-110-66de085967d1b260519403-66f18283c93f6104008002.png",
            "size": 19495,
            "question": 52,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1270-110-66de085967d1b260519403-66f18283c93f6104008002.png",
            "ratio": 5.33
        }
    },
    {
        "id": 53,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point C ?",
        "isVerified": true,
        "options": [
            {
                "id": 159,
                "proposal": "\\( (3\\ 5) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 53
            },
            {
                "id": 158,
                "proposal": "\\( (5 \\\\; 3) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 53
            },
            {
                "id": 157,
                "proposal": "\\( (3 \\\\; 5) \\)",
                "explanation": "La position du point C sur l\u0027axe horizontal est : \\( 3 \\)\r\nLa position sur l\u0027axe vertical est : \\( 5 \\).\r\nSes coordonn\u00e9es sont (3; 5)",
                "isCorrect": true,
                "question": 53
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 14,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1271-119-66dea6d5a68a1384016268-66f1825bc7675094616935.png",
            "size": 17664,
            "question": 53,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1271-119-66dea6d5a68a1384016268-66f1825bc7675094616935.png",
            "ratio": 5.33
        }
    },
    {
        "id": 51,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point A ?",
        "isVerified": true,
        "options": [
            {
                "id": 153,
                "proposal": "\\( (2\\ 3) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 51
            },
            {
                "id": 151,
                "proposal": "\\( (2 \\\\; 3) \\)",
                "explanation": "La position du point A sur l\u0027axe horizontal est : \\( 2 \\)\r\nLa position sur l\u0027axe vertical est : \\( 3 \\).\r\nSes coordonn\u00e9es sont (2; 3)",
                "isCorrect": true,
                "question": 51
            },
            {
                "id": 152,
                "proposal": "\\( (3 \\\\; 2) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 51
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 13,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1271-118-66dea68a5ee89620781659-66f18251c9154634634229.png",
            "size": 18176,
            "question": 51,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1271-118-66dea68a5ee89620781659-66f18251c9154634634229.png",
            "ratio": 5.33
        }
    },
    {
        "id": 54,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point D ?",
        "isVerified": true,
        "options": [
            {
                "id": 162,
                "proposal": "\\( (-3\\ 4) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 54
            },
            {
                "id": 160,
                "proposal": "\\( (-3 \\\\; 4) \\)",
                "explanation": "La position du point D sur l\u0027axe horizontal est : \\( -3 \\)\r\nLa position sur l\u0027axe vertical est : \\( 4 \\).\r\nSes coordonn\u00e9es sont (-3; 4)",
                "isCorrect": true,
                "question": 54
            },
            {
                "id": 161,
                "proposal": "\\( (4 \\\\; -3) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 54
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 19,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1270-109-66de0803b2dc8141917970-66f1828cf015a390870517.png",
            "size": 18264,
            "question": 54,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1270-109-66de0803b2dc8141917970-66f1828cf015a390870517.png",
            "ratio": 5.33
        }
    },
    {
        "id": 57,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point G ?",
        "isVerified": true,
        "options": [
            {
                "id": 169,
                "proposal": "\\( (5 \\\\; -2) \\)",
                "explanation": "La position du point G sur l\u0027axe horizontal est : \\( 5 \\)\r\nLa position sur l\u0027axe vertical est : \\( -2 \\).\r\nSes coordonn\u00e9es sont (5; -2)",
                "isCorrect": true,
                "question": 57
            },
            {
                "id": 171,
                "proposal": "\\( (5\\ -2) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 57
            },
            {
                "id": 170,
                "proposal": "\\( (-2 \\\\; 5) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 57
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 16,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1271-116-66dea5f244d25735706524-66f182711d822582677913.png",
            "size": 15883,
            "question": 57,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1271-116-66dea5f244d25735706524-66f182711d822582677913.png",
            "ratio": 5.33
        }
    },
    {
        "id": 60,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point J ?",
        "isVerified": true,
        "options": [
            {
                "id": 179,
                "proposal": "\\( (-4 \\\\; -3) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 60
            },
            {
                "id": 178,
                "proposal": "\\( (-3 \\\\; 4) \\)",
                "explanation": "La position du point J sur l\u0027axe horizontal est : \\( -3 \\)\r\nLa position sur l\u0027axe vertical est : \\( -4 \\).\r\nSes coordonn\u00e9es sont (-3; -4)",
                "isCorrect": true,
                "question": 60
            },
            {
                "id": 180,
                "proposal": "\\( (-3\\ -4) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 60
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 20,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1270-104-66de0688e22fd320189179-66f182956d8b5457358560.png",
            "size": 18638,
            "question": 60,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1270-104-66de0688e22fd320189179-66f182956d8b5457358560.png",
            "ratio": 5.33
        }
    },
    {
        "id": 59,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point I ?",
        "isVerified": true,
        "options": [
            {
                "id": 176,
                "proposal": "\\( (-2 \\\\; -4) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 59
            },
            {
                "id": 177,
                "proposal": "\\( (-4\\ -2) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 59
            },
            {
                "id": 175,
                "proposal": "\\( (-4 \\\\; -2) \\)",
                "explanation": "La position du point I sur l\u0027axe horizontal est : \\( -4 \\)\r\nLa position sur l\u0027axe vertical est : \\( -2 \\).\r\nSes coordonn\u00e9es sont (-4; -2)",
                "isCorrect": true,
                "question": 59
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 17,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1271-114-66dea5362da02066971502-66f1827a90fcd266086483.png",
            "size": 15942,
            "question": 59,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1271-114-66dea5362da02066971502-66f1827a90fcd266086483.png",
            "ratio": 5.33
        }
    },
    {
        "id": 56,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point F ?",
        "isVerified": true,
        "options": [
            {
                "id": 166,
                "proposal": "\\( (-4 \\\\; 2) \\)",
                "explanation": "La position du point F sur l\u0027axe horizontal est : \\( -4 \\)\r\nLa position sur l\u0027axe vertical est : \\( 2 \\).\r\nSes coordonn\u00e9es sont (-4; 2)",
                "isCorrect": true,
                "question": 56
            },
            {
                "id": 167,
                "proposal": "\\( (2 \\\\; -4) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 56
            },
            {
                "id": 168,
                "proposal": "\\( (-4\\ 2) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 56
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 22,
            "file": null,
            "width": "1281",
            "height": "481",
            "name": "52-137-66d70b9bac8eb725160440-66f182a615459213973800.png",
            "size": 72618,
            "question": 56,
            "filePath": "http://172.16.238.11:9000/questions/52-137-66d70b9bac8eb725160440-66f182a615459213973800.png",
            "ratio": 2.66
        }
    },
    {
        "id": 58,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point H ?",
        "isVerified": true,
        "options": [
            {
                "id": 173,
                "proposal": "\\( (-1 \\\\; 3) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 58
            },
            {
                "id": 172,
                "proposal": "\\( (3 \\\\; -1) \\)",
                "explanation": "La position du point H sur l\u0027axe horizontal est : \\( 3 \\)\r\nLa position sur l\u0027axe vertical est : \\( -1 \\).\r\nSes coordonn\u00e9es sont (3; -1)",
                "isCorrect": true,
                "question": 58
            },
            {
                "id": 174,
                "proposal": "\\( (3\\ -1) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 58
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 21,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1270-102-66de05c68341b672386080-66f1829daeeaf624449151.png",
            "size": 17115,
            "question": 58,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1270-102-66de05c68341b672386080-66f1829daeeaf624449151.png",
            "ratio": 5.33
        }
    },
    {
        "id": 55,
        "query": "Dans le rep\u00e8re ci-contre, quelles sont les coordonn\u00e9es du point E ?",
        "isVerified": true,
        "options": [
            {
                "id": 164,
                "proposal": "\\( (5 \\\\; -1) \\)",
                "explanation": "L\u0027abscisse et l\u0027ordonn\u00e9e ont \u00e9t\u00e9 invers\u00e9s.",
                "isCorrect": false,
                "question": 55
            },
            {
                "id": 163,
                "proposal": "\\( (-1 \\\\; 5) \\)",
                "explanation": "La position du point E sur l\u0027axe horizontal est : \\( -1 \\)\r\nLa position sur l\u0027axe vertical est : \\( 5 \\).\r\nSes coordonn\u00e9es sont (-1; 5)",
                "isCorrect": true,
                "question": 55
            },
            {
                "id": 165,
                "proposal": "\\( (-1\\ 5) \\)",
                "explanation": "Pour s\u00e9parer l\u0027abscisse de l\u0027ordonn\u00e9e, il ne faut pas oublier le point virgule.",
                "isCorrect": false,
                "question": 55
            }
        ],
        "levelA": {
            "id": 6,
            "identifier": 182,
            "task": "Se rep\u00e9rer dans le plan",
            "isPublished": true,
            "levelAGrade": {
                "id": 10,
                "name": "5\u1d49",
                "rank": 10,
                "shortDescription": "La classe de 5\u1d49 correspond au premier niveau du cycle 4, la s\u00e9rie ne comportera donc que des questions de ce niveau",
                "gradeCycle": {
                    "id": 4,
                    "name": "Cycle 4",
                    "shortDescription": "Le cycle 4, ou cycle des approfondissements, comprend les classes de cinqui\u00e8me, quatri\u00e8me et troisi\u00e8me."
                }
            },
            "levelASubtheme": {
                "id": 3,
                "name": "Rep\u00e9rage dans le plan",
                "shortDescription": null,
                "isPublished": true,
                "subthemeTheme": {
                    "id": 1,
                    "identifier": 0,
                    "name": "Nombres et calcul",
                    "shortDescription": "Dans ce th\u00e8me, tu vas pratiquer diff\u00e9rents types de calculs comme le calcul pos\u00e9, le calcul litt\u00e9ral, le calcul mental et le calcul r\u00e9fl\u00e9chi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
                }
            },
            "levelAKnowledge": {
                "id": 6,
                "identifier": 182,
                "keyword": "Se rep\u00e9rer dans le plan",
                "definition": "Pour rep\u00e9rer un point dans un rep\u00e8re, on cherche :\n- son abscisse, sa position sur l\u0027axe horizontal\n- son ordonn\u00e9e, sa position sur l\u0027axe vertical\n- on note le tout sous la forme de coordonn\u00e9es (abscisse ; ordonn\u00e9e).",
                "type": "Method"
            }
        },
        "questionPicture": {
            "id": 15,
            "file": null,
            "width": "1280",
            "height": "240",
            "name": "plan-de-travail-1271-119-66dea6d5a68a1384016268-66f18266050df310883547.png",
            "size": 17664,
            "question": 55,
            "filePath": "http://172.16.238.11:9000/questions/plan-de-travail-1271-119-66dea6d5a68a1384016268-66f18266050df310883547.png",
            "ratio": 5.33
        }
    }
]
export const kFakeLegalContent = {
    keyName: "privacy_policy",
    title: 'Politique de confidentialité (Fake)',
    content: "<div>Bienvenue sur Ummia. Cette politique de confidentialité a pour but de vous informer sur la manière dont nous collectons, utilisons et protégeons les informations personnelles que vous pourriez nous fournir en utilisant notre application. Nous prenons la protection de vos données personnelles très au sérieux et nous nous engageons à les traiter de manière confidentielle.<br><br></div><h1>1. Données collectées</h1><div>Lors de votre utilisation de notre application, nous pouvons collecter les types de données suivants :</div><ul><li><strong>Les données de navigation</strong> : Nous conservons de manière anonymisée, le passage sur chaque page / écran de l'application pour en faire des statistiques de navigation globales.</li><li><strong>L'avancement sur un \"flash\"</strong> : Afin de vous renvoyer à l'étape à laquelle vous vous seriez subitement arrêté.e pendant une série de questions flash, nous enregistrons et conservons chaque étape parcourue dans le \"local storage\" de votre navigateur. Vous pouvez à tout moment supprimer ces données stockées en vidant les caches de votre navigateur.</li></ul><div><br></div><h1>2. Utilisation des données</h1><div>Nous utilisons les données collectées uniquement à des fins de gestion de l'application, d'analyse de l'utilisation et d'amélioration de l'expérience utilisateur. Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers à des fins commerciales.<br><br></div><h1>3. Sécurité des données</h1><div>Nous mettons en place des mesures de sécurité appropriées pour protéger vos données personnelles contre la perte, l'accès non autorisé, la divulgation, la modification ou la destruction. Cependant, veuillez noter qu'aucune transmission de données sur Internet n'est totalement sécurisée, et nous ne pouvons garantir la sécurité absolue de vos données.<br><br></div><h1>4. Liens vers des sites externes</h1><div>Notre application peut contenir des liens vers des sites web tiers. Nous ne sommes pas responsables de la politique de confidentialité ou des pratiques de ces sites tiers. Nous vous encourageons à consulter les politiques de confidentialité de ces sites avant de fournir des données personnelles.<br><br></div><h1>5. Modifications de cette politique</h1><div>Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera affichée sur cette page avec une date de mise à jour. Nous vous encourageons à consulter régulièrement cette politique pour rester informé des modifications éventuelles.<br><br></div><h1>6. Contact</h1><div>Si vous avez des questions ou des préoccupations concernant cette politique de confidentialité, veuillez nous contacter à l'adresse suivante : contact@ummia.fr</div>",
    updatedAt: "2024-11-15T15:50:00+00:00"
}
export const kFakeThemes = [
    {
        "id": 1,
        "identifier": 0,
        "name": "Nombres et calcul",
        "shortDescription":
            "Dans ce thème, tu vas pratiquer différents types de calculs comme le calcul posé, le calcul littéral, le calcul mental et le calcul réfléchi. Et ce, avec de nouveaux types de nombre et notamment les fractions et les nombres relatifs."
    },
    {
        "id": 2,
        "identifier": 1,
        "name": "Espace et géométrie",
        "shortDescription":
            "C'est la discipline qui étudie les figures du plan et de l'espace telles que le cercle, le carré, le rectangle ou encore le prisme. Grâce à des propriétés et des théorèmes connus, tu pourras entre autre calculer des longueurs, prouver le parallélisme et la perpendicularité dans une figure."
    },
    {
        "id": 3,
        "identifier": 2,
        "name": "Grandeurs et mesures",
        "shortDescription":
            "Dans ce thème, tu vas manipuler des grandeurs de la vie des tous les jours. Par exemple, des longueurs, des aires, des durées, des masses ou encore des volumes. Tu vas être amené à créer un répertoire de formule qui te permettront de les mesurer."
    },
    {
        "id": 4,
        "identifier": 3,
        "name": "Organisation et gestion de données",
        "shortDescription":
            "Dans ce thème, tu vas apprendre à utiliser, représenter et interpréter des informations de la vie quotidienne. Pour ce faire, tu utiliseras les outils mathématiques suivants : les fonctions, les probabilités et les statistiques."
    },
    {
        "id": 5,
        "identifier": 4,
        "name": "Algorithmique",
        "shortDescription":
            "Ce thème, que tu travailleras pleinement à partir de la 5ᵉ, t'enseignes ce qu'est un algorithme. Cette notion, très souvent utilisée en informatique, se compose d'une suite d'instructions comme des boucles, des conditions et des opérations."
    }
];
